import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert } from 'antd';
import { loginAction, registerAction } from '../../redux/actions/auth';

const Auth = () => {
    const [signUp, setSignUp] = useState(false);
    const [authData, setAuthData] = useState({
        username:"",
        email: "",
        password: "",
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const returnTo = location.state?.from?.pathname || searchParams.get('returnTo');
    const redirectTo = returnTo?.startsWith('/cms/') ? returnTo : '/cms/home';
    const sessionExpired = location.state?.sessionExpired || searchParams.get('sessionExpired') === '1';

    const onChangeFnc = (e) => {
        setAuthData({...authData, [e.target.name] : e.target.value})
    }
    const authFunc = async () => {
        if(signUp) {
            await dispatch<any>(registerAction(authData, navigate));
        } else {
            await dispatch<any>(loginAction(authData, navigate, redirectTo));
        }
    }

    console.log(authData, "authdata")

  return (
    <div className='w-full h-screen bg-gray-100 flex items-center justify-center fixed top-0 right-0 bottom-0 left-0 z-50'>
        <div className='w-1/3 bg-white p-3 rounded-md shadow-md'>
            <h1 className='text-2xl text-indigo-600 font-medium uppercase'>{signUp ? "Register" : "Login"}</h1>
            {sessionExpired && !signUp && (
                <Alert
                    className="mt-3"
                    type="warning"
                    showIcon
                    message="Oturum süreniz doldu. CMS’e devam etmek için yeniden giriş yapın."
                />
            )}
            <div className='flex flex-col space-y-3 my-5'>
                {signUp && <input value={authData.username} name="username"  onChange={onChangeFnc} type='text' placeholder='Username' className='input-style' />}
                <input value={authData.email} name="email" type='text' onChange={onChangeFnc} placeholder='Email' className='input-style' />
                <input value={authData.password} name="password" type='password' onChange={onChangeFnc} placeholder='Password' className='input-style' />
                {signUp ? <div className='my-5 text-indigo-500 cursor-pointer text-sm hover:font-bold' onClick={() => setSignUp(false)}>Daha önce giriş yaptınızmı?</div> : <div onClick={() => setSignUp(true)} className='my-5 text-indigo-500 cursor-pointer text-sm hover:font-bold'>Kayıt Olmak İçin Tıklayınız</div>}
                <div onClick={authFunc} className='w-full cursor-pointer hover:bg-indigo-700 p-2 text-center bg-indigo-500 text-white rounded-md mt-4'>{signUp ? "Kayıt Ol" : "Giriş Yap"}</div>
            </div>
        </div>
    </div>
  )
}

export default Auth